export const cacheTTLs: { [a: string]: number } = {
  default: 60 * 60 * 1000, // 1 hour
  articles: 60 * 60 * 1000, // 1 hour
  classes: 60 * 60 * 1000, // 1 hour
  events: 10 * 60 * 1000, // 10 minutes
  theaterTalks: 10 * 60 * 1000, // 10 minutes
  userProfile: 60 * 60 * 1000, // 1 hour
  kudos: 15 * 60 * 1000, // 15 minutes
  comments: 15 * 60 * 1000, // 15 minutes
};
